import { Flex, Heading } from '@chakra-ui/layout';
import { UnfilledError } from 'components';
import { BodyProps } from 'constants/MultipleAcorddions';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { ROPACtx } from '..';
import { getROPAFinishPosition } from 'services/ROPAConclusion';
import { useParams } from 'react-router-dom';

const doneImg = require('assets/images/form-done.svg').default;

const Img = styled.img`
  max-width: 600px;
  margin-bottom: 20px;
`;

interface IProps extends BodyProps {
  isDone?: boolean;
  unfilledSteps: string[];
  loading?: boolean;
}

interface IParams {
  id: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Item: React.FC<IProps> = ({ isDone, unfilledSteps, loading }) => {
  const { id } = useParams<IParams>();

  const ctx = useContext(ROPACtx);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { load, setIsLoad } = useContext(ROPACtx);

  const [unfilledStepRef, setUnfilledStepRef] = useState<string[]>(unfilledSteps);

  const unfilled: number[] = [1, 2, 3, 4, 5, 6, 7];

  const unfilledStep: string[] = [
    '1 - Informações Orientadoras',
    '2 - Informações Básicas',
    '3 - Informações Adicionais',
    '4 - Consentimento',
    '5 - Sistemas',
    '6 - Relatório de Impacto',
    '7 - Incidentes de Segurança',
  ];

  // eslint-disable-next-line prefer-const
  let unfilledStepsRef: string[] = [];

  const getFormConclusions = async (finishForm: number) => {
    const id = ctx.data.id as number;
    if (!id) return;
    const response = await getROPAFinishPosition(finishForm, id);

    if (!response.data) {
      if (unfilledStep[finishForm - 1][0] === String(finishForm)) {
        unfilledStepsRef.push(unfilledStep[finishForm - 1]);
      }
    } else {
      const index = unfilledStepsRef.indexOf(unfilledStep[finishForm - 1]);
      if (index > -1) unfilledStepsRef.splice(index, 1);
    }
    setUnfilledStepRef([...unfilledStepsRef]);
  };

  useEffect(() => {
    (() => {
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!id && !load) {
        if (
          (ctx.data.status === 'DONE' &&
            (unfilledSteps.length !== 0 || unfilledStepsRef.length !== 0)) ||
          ctx.data.status === 'DRAFT'
        ) {
          unfilled.forEach(item => {
            getFormConclusions(item);
          });
        }
      }
    })();
  }, [load]);

  // eslint-disable-next-line no-extra-boolean-cast
  if (!!id && unfilledStepRef.length > 0) {
    return <UnfilledError unfilledSteps={unfilledStepRef.sort()} />;
  }

  if (unfilledSteps.length > 0) {
    return <UnfilledError unfilledSteps={unfilledSteps} />;
  }
  return (
    <Flex alignItems="center" marginTop="1rem" width="100%" direction="column">
      <Img src={doneImg} />
      <Heading mb=".8rem" size="lg" as="h3">
        Informações salvas com sucesso!
      </Heading>
    </Flex>
  );
};

export const Conclusions = Item;
